import { postUserRoles, type UserRoleCreateDto } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { USERS_ROLES } from "Settings/User/Api/Query/useUserRolesQuery";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const userMutationsResource = Resources.base.user.mutations;

export const useCreateUserRole = () => {
	const { t } = useResource();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: processResponse((data: UserRoleCreateDto) =>
			postUserRoles(data),
		),
		onError: (error) => {
			console.error(`${t(userMutationsResource.userCreateRoleError)}:`, error);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [USERS_ROLES] });
			toast.success(t(userMutationsResource.userCreateRoleSuccess));
		},
	});
};
